import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/inventoryCycleCountFrequencyReport'
import Component from 'components/Reports/InventoryCycleCountFrequencyReport'

export default createListViewContainer({ actions, selectors: selectors.inventoryCycleCountFrequencyReport })(Component)
